import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import EmailIcon from "@mui/icons-material/Email";
import ArticleIcon from "@mui/icons-material/Article";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import "./MyTechProfileFooter.css";
import { useSelector } from "react-redux";

const ReusableInfoSection = ({
  icon,
  title,
  mainText,
  subText,
  href,
  withArrow,
  className,
}) => {
  const content = (
    <div
      className={`mytechprofileFooterComponent-reusable-section ${
        className || ""
      }`}
    >
      <div className="mytechprofileFooterComponent-reusable-header">
        {icon}
        <span className="mytechprofileFooterComponent-reusable-title">
          {title}
        </span>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          padding: "10px 20px",
        }}
      >
        <p className="mytechprofileFooterComponent-reusable-maintext">
          {mainText}
          {withArrow && (
            <ArrowForwardIcon className="mytechprofileFooterComponent-arrow-icon" />
          )}
        </p>
        <p className="mytechprofileFooterComponent-reusable-subtext">
          {subText}
        </p>
      </div>
    </div>
  );

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="mytechprofileFooterComponent-reusable-link"
      >
        {content}
      </a>
    );
  }

  return content;
};

const ContactDrawer = ({ isOpen, onClose, linkChangedFor }) => {
  const { profile } = useSelector((state) => state.editMyTechProfileStore);
  if (!isOpen) return null;

  return (
    <div
      className="mytechprofileFooterComponent-drawer-overlay"
      onClick={onClose}
    >
      <div
        className="mytechprofileFooterComponent-drawer"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="mytechprofileFooterComponent-drawer-close"
        >
          <CancelIcon />
        </button>

        <div className="mytechprofileFooterComponent-drawer-socials">
          {profile?.linkedinLink?.length > 0 && (
            <a
              href={profile?.linkedinLink}
              target="_blank"
              rel="noopener noreferrer"
              className={
                linkChangedFor === "linkedin" ? "pulse-effect-golden-icon" : ""
              }
            >
              <LinkedInIcon size={32} />
            </a>
          )}

          {profile?.githubLink?.length > 0 && (
            <a
              href={profile?.githubLink}
              target="_blank"
              rel="noopener noreferrer"
              className={
                linkChangedFor === "github" ? "pulse-effect-golden-icon" : ""
              }
            >
              <GitHubIcon size={32} />
            </a>
          )}
        </div>

        <div className="mytechprofileFooterComponent-drawer-content-wrapper">
          <ReusableInfoSection
            icon={<EmailIcon sx={{ color: "#fff" }} />}
            title="Email"
            mainText={profile?.email}
            subText="Send email directly"
            href={`mailto:${profile?.email}`}
          />

          {/* Conditionally apply pulse effect class for Resume */}
          <ReusableInfoSection
            icon={<ArticleIcon sx={{ color: "#fff" }} />}
            title="Resume"
            mainText="View my Resume"
            subText="Check out my experience"
            href={profile?.resumeLink}
            withArrow={true}
            className={linkChangedFor === "resume" ? "pulse-effect-golden" : ""}
          />
        </div>

        <div className="mytechprofileFooterComponent-availability">
          <div className="mytechprofileFooterComponent-pulse-dot"></div>
          <span>Available for new opportunities</span>
        </div>
      </div>
    </div>
  );
};

export default ContactDrawer;
